import {Injectable} from '@angular/core';
import {Headers, Http, URLSearchParams, RequestOptions} from '@angular/http';
import {CarTemplate} from "./model/car-template";
import {CarTemplateFilter} from "./model/car-template-filter";
import 'rxjs/add/operator/map';

@Injectable()
export class CarTemplateService {

    PAGE_NUMBER = "pageNumber";
    ITEMS_PER_PAGE = "itemsPerPage";
    CONTENT_TYPE = "Content-Type";
    APPLICATION_JSON = 'application/json'

    private baseUrlWithCompany: string = '../rest/company/';
    private baseUrlWithoutCompany: string = '../rest/';
    private dataUrl: string = '../rest/data/';
    private carTemplateUrl:string = 'carTemplate';
    private carCategoriesUrl = 'carCategories';
    private carTypes = 'carTypes';
    private approvalStatus = 'carTemplateStatus';
    private modelsUrl = 'models';
    private brandsUrl = 'brands';

    constructor(private http : Http) {}

    getById(companyOid, id){
        return this.http
            .get(`${this.baseUrlWithCompany}${companyOid}/${this.carTemplateUrl}/${id}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    getAllByCompany(carTemplateFilter: CarTemplateFilter, currentPage:number, itemsPerPage:number){
        return this.http
            .get(`${this.baseUrlWithCompany}${carTemplateFilter.companyId}/${this.carTemplateUrl}`, this.getRequestOptions(carTemplateFilter, currentPage, itemsPerPage))
            .map((response) => response.json());
    }

    getAll(carTemplateFilter: CarTemplateFilter, currentPage:number, itemsPerPage:number){
        return this.http.get(`${this.baseUrlWithoutCompany}${this.carTemplateUrl}`, this.getRequestOptions(carTemplateFilter, currentPage, itemsPerPage)).map((response) => response.json());
    }

    getAllCarCategories() {
       return this.http.get(`${this.dataUrl}${this.carCategoriesUrl}`,  { headers: this.getHeaders()}).map((response) => response.json());
    }

    getAllCarTypes() {
       return this.http.get(`${this.dataUrl}${this.carTypes}`,  { headers: this.getHeaders()}).map((response) => response.json());
    }

     getAllModelsByBrand(companyOid:number, brand:string) {
       let params = new URLSearchParams();
       params.append('all', "true");
       let options = new RequestOptions({headers: this.getHeaders(), search:params});
       return this.http.get(`${this.dataUrl}${this.modelsUrl}/`+brand+`/`+companyOid, options).map((response) => response.json());;
     }

    getAllApprovalStatus() {
        return this.http.get(`${this.dataUrl}${this.approvalStatus}`,  { headers: this.getHeaders()}).map((response) => response.json());;
    }

    getAllBrands(companyOid:number) {
        let params = new URLSearchParams();
        params.append('all', "true");
        let options = new RequestOptions({headers: this.getHeaders(), search:params});
        return this.http.get(`${this.dataUrl}${this.brandsUrl}/` + companyOid, options).map((response) => response.json());;
    }

    save(carTemplate: CarTemplate, companyOid: number) {
        return this.http.post(`${this.baseUrlWithCompany}${companyOid}/${this.carTemplateUrl}`, carTemplate);
    }

    update(carTemplate: CarTemplate, companyOid: number) {
        return this.http.put(`${this.baseUrlWithCompany}${companyOid}/${this.carTemplateUrl}`, carTemplate);
    }

    updatePicture(carTemplate: CarTemplate, companyOid: number) {
       return this.http.put(`${this.baseUrlWithCompany}${companyOid}/${this.carTemplateUrl}/picture`, carTemplate);
    }

    remove(companyOid: number, id: number) {
       return this.http.delete(`${this.baseUrlWithCompany}${companyOid}/${this.carTemplateUrl}/` + id);
    }

    moderate(carTemplate: CarTemplate, status:string) {
        return this.http.patch(`${this.baseUrlWithoutCompany}${this.carTemplateUrl}/${carTemplate.oid}`, {status: status});
    }

    moderateModelPicture(carTemplate: CarTemplate, status:string) {
        return this.http.patch(`${this.baseUrlWithoutCompany}${this.carTemplateUrl}/${carTemplate.oid}/picture`, {status: status});
    }

    private getRequestOptions(carTemplateFilter: CarTemplateFilter, currentPage:number, itemsPerPage:number) {
      let params = new URLSearchParams();
      for (let key of Object.keys(carTemplateFilter)) {
        if (!!carTemplateFilter[key]) {
            params.append(key, carTemplateFilter[key]);
        }
      }
      params.append(this.PAGE_NUMBER, String(currentPage));
      params.append(this.ITEMS_PER_PAGE, String(itemsPerPage));
      return new RequestOptions({headers: this.getHeaders(), search:params});
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append(this.CONTENT_TYPE, this.APPLICATION_JSON);
        return myHeaders;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/car-template.service.ts